import { EditIcon } from 'lucide-react';
import React, { useState } from 'react';
import { MdEdit } from "react-icons/md";
const InterestTags = ({
  tags,
  onCreate,
  onUpdate,
  maxTags,
  disableInput,
  loading,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [editingTag, setEditingTag] = useState(null);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleAddOrUpdate = () => {
    if (editingTag) {
      onUpdate(editingTag.id, inputValue);
      setEditingTag(null);
    } else {
      onCreate(inputValue);
    }
    setInputValue('');
  };

  const handleEdit = (tag) => {
    setEditingTag(tag);
    setInputValue(tag.name);
  };

  const handleCancel = () => {
    setEditingTag(null);
    setInputValue('');
  };

  console.log("tags Data" , tags)

  return (
    <div className="mb-8">
     
      <div className="flex justify-between items-center">
        <h1 className="text-xl font-bold">Interest Tags</h1>
        <span
          className={`text-sm ${
            tags.length >= maxTags * 0.8 ? 'text-red-500' : 'text-gray-500'
          }`}
        >
          {tags.length}/{maxTags} Interest Tags used
        </span>
      </div>

    
      <div className="flex gap-16 mt-4">
  
        <div className="custom-scrollbar overflow-x-hidden flex flex-wrap flex-auto w-7/12 h-64 rounded-md p-3 gap-x-2 gap-y-2 bg-appGrayBackground overflow-y-auto">
          {tags.map((item) => (
            <div
              key={item.id}
              className="bg-customGreen h-8 rounded-lg px-3 text-sm font-normal text-white mr-2 mb-2 flex items-center"
            >
              <span>{item.name}</span>
              <button
                className="ml-2 focus:outline-none"
                onClick={() => handleEdit(item)}
                
              >
                <MdEdit className="w-4 h-4 text-white" />
              </button>
            </div>
          ))}
        </div>

        {/* Input and actions */}
        <div className="flex flex-col w-5/12">
          <div className="flex gap-4 items-start">
            <div className="flex flex-col gap-1 max-w-md w-full">
              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                maxLength={50}
                placeholder="Enter interest tag"
                className="px-4 py-2 h-10 text-sm rounded-md border border-gray-300 input-focus"
                disabled={tags.length >= maxTags && !editingTag}
              />
<div className="text-sm text-gray-500 mt-2">
  Add tags like: Landscaping, Gardening, Budget Land, etc.
</div>


            </div>
            <div className="flex gap-2">
              <button
                onClick={handleAddOrUpdate}
                disabled={
                  (tags.length >= maxTags && !editingTag) || loading
                }
                className={`h-10 px-4 text-sm font-medium rounded-md transition duration-200 ${
                  loading
                    ? 'text-gray-400 bg-gray-200 cursor-not-allowed'
                    : tags.length >= maxTags && !editingTag
                    ? 'text-red-400 bg-red-100 cursor-not-allowed'
                    : 'text-white bg-customGreen'
                }`}
              >
                {loading ? 'Loading...' : editingTag ? 'Update' : 'Add'}
              </button>

              {editingTag && (
                <button
                  onClick={handleCancel}
                  className="h-10 px-4 text-sm font-medium rounded-md transition duration-200 text-white bg-gray-500 hover:bg-gray-600"
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterestTags;
